import { useStoreState } from '../model';

export const useSubscription = () => {
    const subscription = useStoreState((state) => state.subscription);
    if (!subscription.loaded) return false;
    return subscription.subscription;
};
